/**
 * inProgressChipStyles.ts
 *
 * The small "something is running" chip that sits in the transcript header
 * while a background job (a translation, a dub) is in flight: a 12px ring
 * spinner beside a muted label. Extracted from TranslationToggle's
 * "Translating…" state (PLAT-11570) so the dub run chip shares the exact look
 * rather than copying it.
 */
import styled from 'styled-components';

export const InProgressChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  color: var(--text-secondary);
  font-size: var(--text-sm);
`;

export const InProgressSpinner = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: in-progress-chip-spin 0.8s linear infinite;

  @keyframes in-progress-chip-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const InProgressText = styled.span`
  font-size: var(--text-xs);
  opacity: 0.85;
`;
